<template>
  <div>
    <div tabindex="0" ref="modal" class="modal-mask"></div>

    <rare-modal-close-icon-large
      class="rareModalCloseIcon show-for-medium"
      @clicked="closeModal"
    />

    <rare-modal-close-icon-medium
      class="rareModalCloseIcon show-for-small-only"
      @clicked="closeModal"
    />

    <div class="modal-wrapper">
      <div class="modal-container">

        <div class="modal-header">
          <div class="grid-container full page-contents-15">
            <div class="grid-x">
              <div class="small-12 cell text-left">
                <h1>Get in touch</h1>
                <hr/>
              </div>
            </div>
            <div class="grid-x">
              <div class="small-12 medium-6 cell text-left">

                <p><strong>Business enquiries:</strong></p>
                <p>
                  <a href="mailto:newbusiness@rarerecruitment.co.uk" class="contact-link">
                    <rare-email-icon class="contact-icon" />
                    <span>newbusiness@rarerecruitment.co.uk</span>
                  </a>
                </p>

                <p style="margin-top: 30px; "><strong>Press enquiries:</strong></p>
                <p>
                  <a href="mailto:press@rarerecruitment.co.uk" class="contact-link" >
                    <rare-email-icon class="contact-icon" style="margin-left: -11px; "/>
                    <span>press@rarerecruitment.co.uk</span>
                  </a>
                </p>

                <p style="margin-top: 30px; "><strong>Current client enquiries:</strong></p>
                <p>
                  <a href="mailto:currentclients@rarerecruitment.co.uk" class="contact-link">
                    <rare-email-icon class="contact-icon" />
                    <span>currentclients@rarerecruitment.co.uk</span>
                  </a>
                </p>

              </div>
              <div class="small-12 medium-6 cell text-left">

                <p><strong>Candidate and student society enquiries:</strong></p>
                <p class="contact-details" style="margin-top: -16px; ">
                  <a href="https://www.rarerecruitment.co.uk/faq" class="contact-link">
                    <rare-web-icon class="contact-icon" />
                    <span>View our FAQs</span>
                  </a>
                </p>

                <p style="margin-top: 30px; "><strong>To apply to join Rare as a candidate:</strong></p>
                <p class="contact-details" style="margin-top: -16px; ">
                  <a href="https://rare.app.candidx.io/roles" class="contact-link" target="_blank">
                    <rare-web-icon class="contact-icon" />
                    <span>https://rare.app.candidx.io/roles</span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import RareStandardButton from '@/components/atoms/RareWebButton';
import RareModalCloseIconLarge from 'rare-patternlab/icons/navigation/RareModalCloseIconLargeBlack';
import RareModalCloseIconMedium from 'rare-patternlab/icons/navigation/RareModalCloseIconMediumBlack';

import RareEmailIcon from 'rare-patternlab/icons/communication/RareEmailIcon';
import RareWebIcon from 'rare-patternlab/icons/communication/RareWebIcon';

export default {
  name: 'RareContactModal',
  components: {
    'rare-standard-button': RareStandardButton,
    'rare-modal-close-icon-medium': RareModalCloseIconMedium,
    'rare-modal-close-icon-large': RareModalCloseIconLarge,
    'rare-email-icon': RareEmailIcon,
    'rare-web-icon': RareWebIcon,
  },
  data() {
    return {
    };
  },
  methods: {
    closeModal() {
      this.$emit('closeContactForm');
    },
    watchForEsc(key) {
      if (key.keyCode === 27) {
        this.closeModal();
      }
    },
  },
  mounted() {
    this.$refs.modal.focus();
  },
  created() {
    document.addEventListener('keyup', this.watchForEsc);
  },
  destroyed() {
    document.removeEventListener('keyup', this.watchForEsc);
  },

};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .modal-mask:focus, .modal-mask:active, modal-mask:focus-visible {
    outline: none;
  }

  .contact-link {
    display: inline-block;
    text-decoration: none;
  }

  .contact-link span {
    text-decoration: underline;
  }

   .contact-icon {
     display: inline-block;
     height: 24px;
     margin-left: -11px;
   }

  .modal-mask {
    position: fixed;
    z-index: 9990;
    top: 0;
    left: 0;
    width: 100%;
    height: 200%;
    -webkit-backdrop-filter: blur(30px);
    backdrop-filter: blur(30px);
    display: table;
    transition: opacity .3s ease;
    background-color: rgba(255,255,255, .95);
    overflow: scroll;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    opacity: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9991;
  }

  .modal-container {
    width: 100%;
    margin: 0px auto;
    padding: 0;
    background-color: transparent;
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    opacity: 1;
  }

  .modal-body {
    margin: 0;
  }

  .modal-default-button {
    float: right;
  }

  hr {
    margin: 30px auto 30px 0 !important;
    border-bottom: 1px solid #c4cace;
  }

  h1 {
    color: $main-text;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  }

  p, a {
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  p, h1, h3, a, label {
    color: $main-text;
  }

  label {
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  .field-container {
    overflow: hidden;
    max-height: 50px;
  }

  @media only screen and (max-width: 640px)  {
    .rareModalCloseIcon {
      cursor: pointer;
      position: absolute;
      right: 8px;
      top: 22px;
      z-index: 9995;
    }

    .contact-link:last-of-type {
      margin-left: 0;
    }

    h1 {
      font-size: 24px;
      line-height: 1.33;
      letter-spacing: 3px;
      margin: 80px 0 16px 0;
    }
  }

  @media only screen and (min-width: 641px)  {
    .rareModalCloseIcon {
      cursor: pointer;
      position: absolute;
      right: 124px;
      top: 84px;
      z-index: 9995;
    }

    h1 {
      font-size: 56px;
      line-height: 1.29;
      letter-spacing: 0.8px;
      margin: 88px 0 24px 0;
    }

    p, a {
      font-size: 21px;
      line-height: 1.52;
      letter-spacing: 0.4px;
      margin-bottom: 12px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/forms/RareContactModal.vue